module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("紀錄報表")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27d47634","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ReportExport.vue
// module id = 1416
// module chunks = 1